<!--

@todo: optional email and optional TextBoxTitleThree

An info box that features a photo, name, title, phone number

-->

<template>
  <div class="border border-size">

    <div v-if="image" class="row">
      <div class="col image-flex">
        <img :src="image" />
      </div>
    </div>

    <div class="row p-3">
      <div class="col">
        <div class="row font-size-125 mt-1">
          <div class="col-md-auto text-bold">
            {{name}}
          </div>
        </div>

        <div class="row font-size-125 mt-1">
          <div class="col-md-auto">
            {{title}}
          </div>
        </div>

        <div class="row font-size-125 mt-1">
          <div class="col">
            <!-- <i class="material-icons">call</i>&nbsp;-->{{phone}}
          </div>
        </div>

        <div v-if="email" class="row font-size-125 mt-1">
          <div class="col email_link">
            <a class="" :href="emailText">{{email}}</a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      emailText: ""
    }
  },
  props: ["name","title","phone","email","image"],
  mounted: function() {
    this.formatEmail()
  },
  methods: {
    formatEmail: function() {
      this.emailText = "mailto:" + this.email
    }
  }
}
</script>

<style scoped>
.border-size {
  border-width: 2px !important;
}

.email_link a {
  font-size: 0.8em;
}
</style>
